import React, { useState } from "react";
import styled from "@emotion/styled";
import { VillaRating } from "./VillaRating";
import { VillaVidFavButtons } from "./VillaVidFavButtons";
import { Slideshow } from "./Slideshow";
import withTranslator from "../Translator/withTranslation";
import colors from '../../../sass/brand_palette.scss';

let baseurl = 'https://www.clubvillamar.com';

const ReviewsContainer = styled.div`
    top: 1rem;
    left: 1rem;
`;

const CTAContainer = styled.div`
    bottom: 1rem;
    right: 1rem;
    opacity: .7;
    
    &:hover{
        opacity:1;
    }
`;
const SingleImage = styled.img`
    margin-bottom:-4px;
    width:100%;
`;
const ShowVillaButton = styled.div`
    height: 50%;
    position: absolute;
    top: 25%;
    z-index: 2;
    width: 80%;
    left: 10%;
    justify-content: center;
    align-items: center;
    display: flex;
`;
const ShowVillaButtonContent = styled.div`
    padding: 2rem;
    background: ${colors.orange2};
    border-radius: 3rem;
    color: ${colors.black};
    font-size: 1.5rem;
    font-weight:600;
    cursor: pointer;
    text-align:center;
    -webkit-transition: background-color 0.5s ease-in-out;
    -moz-transition: background-color 0.5s ease-in-out;
    -o-transition: background-color 0.5s ease-in-out;
    transition: background-color 0.5s ease-in-out;
    -moz-appearance: none;
    -webkit-appearance: none;

    @media (max-width: 400px ) {
        font-size: 1rem;
        padding: 1rem;
        line-height:1.5rem;
    }
    &:hover {
        color: white;
        background-color: ${colors.orange1};
        border-color: ${colors.orange1};
    }
`;

const VillaTileImageComponent = (props) => {
    const [showVillaButton, setShowVillaButton] = useState(false);

    const onImageChange = (index) => {
        if (index === (props.data.pictures.length - 1)) {
            setShowVillaButton(true);
        } else {
            setShowVillaButton(false);
        }
    }
    const additionalLabel = () => {
        var params = {
            className: 'px-2 border-radius-default mt-1',
            content: ''
        };
        const { t } = props;
        if(props.data.accommodation_of_the_week){
            params.className += ' bg-orange1';
            params.content = t('villaofweek');
        } else if(props.data.new_online){
            params.className += ' bg-blue2';
            params.content = t('newvilla');
        } else if(props.data.recommended){
            params.className += ' bg-blue2';
            params.content = t('recommended');
        } else if(props.data.best_choice){
            params.className += ' bg-orange2 blue1';
            params.content = t('bestchoice');
        } else return;
        
        return (
            <div className={params.className}>
                {'★ ' + params.content}
            </div>
        );
    }

    const showVilla = (url) => {
        if (typeof window !== 'undefined' ) {
            if (url) {
                props.sendClickEvent();
                window.open(url.replace('http:', ''), '_blank');
            }
        }
        return;
    }

    const images = () => {
        var images = [];
        for(var i = 0; i < props.data.pictures.length; i++){
            let src = props.mobile ? props.data.pictures[i].thumbnailMedium : props.data.pictures[i].thumbnailMediumLarge;
            images.push({
                src: baseurl+src,
                link: props.data.villaUri
            });
        }
        return images;
    }

    const data = props.data;

    return (
        <div className="relative">
            {showVillaButton && <ShowVillaButton >
                <ShowVillaButtonContent onClick={() => showVilla(props.data.villaUri) }>{props.t('click_for_more_pictures')}</ShowVillaButtonContent>
            </ShowVillaButton> }
            {props.data.pictures.length == 1 ? 
            <SingleImage onClick={() => { showVilla(props.data.villaUri)}} className="width-100" src={props.mobile ? baseurl + props.data.pictures[0].thumbnailMedium : baseurl + props.data.pictures[0].thumbnailMediumLarge} />
            :
            <Slideshow
                sendClickEvent={() => {props.sendClickEvent()}}
                images={images()}
                data={props.data}
                preloadCount={props.slideshowImagesPreloadCount}
                lazyloadNext={props.slideshowImagesLazyloadNext}
                onImageChange ={(index) => onImageChange(index)}
            />
            }
            <ReviewsContainer className="absolute white font-80 uppercase text-center">
                <VillaRating
                    data={data}
                    reviewType={props.reviewType}
                    reviewStarText={props.reviewStarText}
                />
                {additionalLabel()}
            </ReviewsContainer>
            {props.vidFavButtonsPosition === 'image' ?
            <CTAContainer className="absolute">
                <VillaVidFavButtons
                    data={data}
                    favouriteVillas={props.favouriteVillas}
                    vidButtonClassName="btn-tertiary bg-orange1-hover"
                    vidButtonIcon="/assets/img/front/icons/video-triangle-blue1.svg"
                    favButtonClassName="btn-tertiary bg-green1-hover"
                    favButtonIcon="/assets/img/front/icons/favourite-heart-blue1.svg"
                    iconHeight="15"
                    favouritedClass="btn-green1"
                    favouritedIcon="/assets/img/front/icons/favourite-heart-reversed.svg"
                />
            </CTAContainer>
            :''}
        </div>
    );
}

export const VillaTileImage = withTranslator(VillaTileImageComponent);